import { useMatch } from "@tanstack/react-router";
import { setupAGGrid } from "@/lib/AGGrid/setupAGGrid";
import { ImportTable } from "@/app/Import/Components/ImportTable";

setupAGGrid();

export function ImportSpreadsheetScreen() {
  const { params } = useMatch({
    from: "/$tenant/$orgId/supplier/{-$supplierId}/import/$importSupplierId",
  });

  return <ImportTable supplierId={params.importSupplierId} />;
}
